
export default function MarketResearch() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#1FA372]/10 text-[#1FA372] rounded-full text-sm font-semibold mb-4 border border-[#1FA372]/20">
            02 — Research
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1E293B] mb-6">
            Market & Behavioral Research
          </h2>
          <p className="text-[#64748B] text-lg max-w-3xl mx-auto">
            Understanding the distinct user psychology and market dynamics between USA and India to create culturally relevant experiences.
          </p>
        </div>

        {/* USA vs India Comparison */}
        <div className="grid lg:grid-cols-2 gap-8 mb-16">
          {/* USA Market */}
          <div className="bg-gradient-to-br from-[#F0FDF9] to-white rounded-3xl p-8 border border-[#1FA372]/20 relative overflow-hidden shadow-sm">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#1FA372]/10 rounded-full blur-2xl"></div>
            <div className="relative">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-[#1FA372]/10 rounded-2xl border border-[#1FA372]/20">
                  <span className="text-3xl">🇺🇸</span>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-[#1E293B]">United States</h3>
                  <span className="text-[#1FA372] text-sm font-medium">Primary Market</span>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-xl p-4 border border-[#E2E8F0] shadow-sm">
                  <h4 className="text-[#1E293B] font-semibold mb-2 flex items-center gap-2">
                    <i className="ri-user-heart-line text-[#1FA372]"></i>
                    User Psychology
                  </h4>
                  <p className="text-[#64748B] text-sm">High expectation for self-service, privacy-focused, prefers automated solutions and minimal human interaction.</p>
                </div>
                <div className="bg-white rounded-xl p-4 border border-[#E2E8F0] shadow-sm">
                  <h4 className="text-[#1E293B] font-semibold mb-2 flex items-center gap-2">
                    <i className="ri-money-dollar-circle-line text-[#1FA372]"></i>
                    Payment Behavior
                  </h4>
                  <p className="text-[#64748B] text-sm">Credit card dominant, ACH transfers, expects auto-pay options and late fee transparency.</p>
                </div>
                <div className="bg-white rounded-xl p-4 border border-[#E2E8F0] shadow-sm">
                  <h4 className="text-[#1E293B] font-semibold mb-2 flex items-center gap-2">
                    <i className="ri-scales-3-line text-[#1FA372]"></i>
                    Compliance Focus
                  </h4>
                  <p className="text-[#64748B] text-sm">Strong emphasis on legal compliance, CC&Rs enforcement, and documented communication trails.</p>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-[#1FA372]/20">
                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center bg-white rounded-xl p-4 border border-[#E2E8F0]">
                    <div className="text-3xl font-bold text-[#1FA372]">370K+</div>
                    <div className="text-[#64748B] text-sm">HOAs in USA</div>
                  </div>
                  <div className="text-center bg-white rounded-xl p-4 border border-[#E2E8F0]">
                    <div className="text-3xl font-bold text-[#1FA372]">74M</div>
                    <div className="text-[#64748B] text-sm">Residents</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* India Market */}
          <div className="bg-gradient-to-br from-[#FFF7ED] to-white rounded-3xl p-8 border border-[#F97316]/20 relative overflow-hidden shadow-sm">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#F97316]/10 rounded-full blur-2xl"></div>
            <div className="relative">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-[#F97316]/10 rounded-2xl border border-[#F97316]/20">
                  <span className="text-3xl">🇮🇳</span>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-[#1E293B]">India</h3>
                  <span className="text-[#F97316] text-sm font-medium">Emerging Market</span>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-xl p-4 border border-[#E2E8F0] shadow-sm">
                  <h4 className="text-[#1E293B] font-semibold mb-2 flex items-center gap-2">
                    <i className="ri-user-heart-line text-[#F97316]"></i>
                    User Psychology
                  </h4>
                  <p className="text-[#64748B] text-sm">Community-oriented, prefers personal touch, values WhatsApp integration and vernacular language support.</p>
                </div>
                <div className="bg-white rounded-xl p-4 border border-[#E2E8F0] shadow-sm">
                  <h4 className="text-[#1E293B] font-semibold mb-2 flex items-center gap-2">
                    <i className="ri-bank-card-line text-[#F97316]"></i>
                    Payment Behavior
                  </h4>
                  <p className="text-[#64748B] text-sm">UPI dominant, cash still prevalent, expects multiple payment reminders and flexible payment plans.</p>
                </div>
                <div className="bg-white rounded-xl p-4 border border-[#E2E8F0] shadow-sm">
                  <h4 className="text-[#1E293B] font-semibold mb-2 flex items-center gap-2">
                    <i className="ri-building-4-line text-[#F97316]"></i>
                    Society Structure
                  </h4>
                  <p className="text-[#64748B] text-sm">Apartment welfare associations, managing committees, emphasis on festival events and community gatherings.</p>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-[#F97316]/20">
                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center bg-white rounded-xl p-4 border border-[#E2E8F0]">
                    <div className="text-3xl font-bold text-[#F97316]">100K+</div>
                    <div className="text-[#64748B] text-sm">Housing Societies</div>
                  </div>
                  <div className="text-center bg-white rounded-xl p-4 border border-[#E2E8F0]">
                    <div className="text-3xl font-bold text-[#F97316]">50M+</div>
                    <div className="text-[#64748B] text-sm">Urban Residents</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Research Methods */}
        <div className="bg-gradient-to-r from-[#F0FDF9] via-white to-[#FFF7ED] rounded-3xl p-8 border border-[#E2E8F0] shadow-sm">
          <h3 className="text-2xl font-bold text-[#1E293B] mb-8 text-center">Research Methodology</h3>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#1FA372]/10 rounded-2xl mx-auto mb-4 border border-[#1FA372]/20">
                <i className="ri-survey-line text-[#1FA372] text-2xl"></i>
              </div>
              <h4 className="text-[#1E293B] font-semibold mb-2">User Surveys</h4>
              <p className="text-[#64748B] text-sm">500+ responses from HOA board members and residents</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#F97316]/10 rounded-2xl mx-auto mb-4 border border-[#F97316]/20">
                <i className="ri-user-voice-line text-[#F97316] text-2xl"></i>
              </div>
              <h4 className="text-[#1E293B] font-semibold mb-2">Interviews</h4>
              <p className="text-[#64748B] text-sm">40+ in-depth interviews with property managers</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#3B82F6]/10 rounded-2xl mx-auto mb-4 border border-[#3B82F6]/20">
                <i className="ri-pie-chart-line text-[#3B82F6] text-2xl"></i>
              </div>
              <h4 className="text-[#1E293B] font-semibold mb-2">Competitive Analysis</h4>
              <p className="text-[#64748B] text-sm">15 competitor platforms analyzed across both markets</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#8B5CF6]/10 rounded-2xl mx-auto mb-4 border border-[#8B5CF6]/20">
                <i className="ri-focus-3-line text-[#8B5CF6] text-2xl"></i>
              </div>
              <h4 className="text-[#1E293B] font-semibold mb-2">Usability Testing</h4>
              <p className="text-[#64748B] text-sm">3 rounds of testing with 60+ participants</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
